import * as React from "react";
import { SVGProps } from "react";
const SvgChevronSmallLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 8a1 1 0 0 1 .561 1.828c-3.273 2.218-5.773 4.293-7.436 6.172 1.665 1.88 4.165 3.956 7.436 6.172a1 1 0 0 1-1.122 1.656c-3.615-2.45-6.248-4.666-8.05-6.777-.52-.605-.52-1.5.001-2.104 1.801-2.11 4.434-4.326 8.05-6.776a.998.998 0 0 1 .44-.164L19 8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronSmallLeft;
